import { render } from "./cardbody.vue?vue&type=template&id=49696072"
import script from "./cardbody.vue?vue&type=script&lang=js"
export * from "./cardbody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__